import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageShell from "@/components/PageShell";
import api from "@/lib/api";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

export default function Courses() {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    api.get("/courses").then((r) => setCourses(r.data));
  }, []);

  return (
    <PageShell>
      <div className="max-w-7xl mx-auto px-6 py-14">
        <span className="text-xs uppercase tracking-widest font-mono text-primary">Curriculum</span>
        <h1 className="font-serif text-5xl mt-2 mb-3">Courses</h1>
        <p className="text-muted-foreground max-w-2xl mb-12">
          Three complementary tracks: the Redemption Manual (money & Secured Party Creditor), the Williams status-
          correction work (the "Person," citizenship & travel), and the Hood Consumer Advisors consumer-empowerment
          curriculum (contracts, FCRA/FDCPA/TILA, pro se & tenant rights).
        </p>

        <div className="grid md:grid-cols-2 gap-px bg-border border border-border">
          {courses.map((c, i) => (
            <motion.div
              key={c.slug}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="bg-card"
            >
              <Link to={`/courses/${c.slug}`} data-testid={`course-card-${c.slug}`} className="flex flex-col sm:flex-row group h-full">
                <div className="sm:w-44 h-40 sm:h-auto bg-cover bg-center grain shrink-0" style={{ backgroundImage: `url('${c.image}')` }} />
                <div className="p-7 flex flex-col">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-[10px] uppercase tracking-widest font-mono text-primary">{c.category}</span>
                    <span className="text-[10px] uppercase tracking-widest font-mono text-muted-foreground border border-border px-2 py-0.5">{c.level}</span>
                  </div>
                  <h2 className="font-serif text-2xl leading-tight mb-2 group-hover:text-primary transition-colors">{c.title}</h2>
                  <p className="text-sm text-muted-foreground leading-relaxed flex-1">{c.summary}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-xs uppercase tracking-widest font-mono text-primary">
                    Study course <ArrowRight className="w-3 h-3" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
